module.exports = __webpack_public_path__ + "img/Group 15.8c93371c.svg";